import { ExternalPageMessages } from '../types';

export const externalZHCN: ExternalPageMessages = {
    'app.external.title.thankyou': '非常感謝您參加BEVI考評。',
    'app.external.thankyou_static_1_1': 'BEVI（the Beliefs, Events, and Values Inventory）是受著作權法保護的測試。BEVI及BEVI的結果、每道問題及其內容、還有各項比例標準，除非得到Craig N. Shealy博士的明確書面許可，否則無權對其全部或一部分進行分發、複製、變更、應用、公開或出版。',
    'app.external.thankyou_static_1_2': '以研究或教育為目的的BEVI中文版的使用權已由Craig N. Shealy博士授予西谷 元 教授（日本廣島大學）。',
    'app.external.thankyou_static_2': '與BEVI考評一樣，此結果的構成和設計將會不斷地被修訂、改善。關於BEVI的考評及結果，若有意見與建議，請直接聯繫info@thebevi.com',
    'app.external.thankyou_static_3': '若想瞭解有關BEVI的更多詳情，請查看International Beliefs and Values Institute（IBAVI）的主頁（www.ibavi.org）及BEVI主頁（thebevi.com）。',
}
